export default () => ({
  root: {}
});
